import { useState } from "react";
import TrackingIcon from '../../assets/img/tracking-icon.svg';
import { Button } from "@chr/eds-react";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import "./TrackingNumberWidget.scss";
import { useAppConfig } from "@/common/utilities/UseAppConfig";

export const TrackingNumberWidget = () => {
    const translate = useTranslation();
    const { searchUiUri } = useAppConfig();
    const [trackingNumber, setTrackingNumber] = useState('');

    const getTrackingIcon = () => {
        return (
          <div className="tracking-icon" data-testid="tracking-icon">
            <img
                src={TrackingIcon}
                alt=""
            />
          </div>
        )
    }

    const getTitle = () => {
        return (
          <div className="tracking-title">
            <span>
              {translate("Enter a tracking number.")}
            </span>
          </div>
        )
    }

    const handleTrackingButtonClick = () => {
        const url = `${searchUiUri}?search=${encodeURIComponent(trackingNumber)}`;
        window.location.assign(url);
    }

    const handleKeyPress = (e: any) => {
        if(e.key == 'Enter'){
            handleTrackingButtonClick();
        }
    }

    const getTrackingInput = () => {
        return (
            <div className="tracking-input">
                <input
                  id="homepage-trackingNumber"
                  data-testid="trackingNumber"
                  type="text"
                  className="tracking-number-input"
                  onChange={(e) => {setTrackingNumber(e.target.value)}}
                  onKeyDown={handleKeyPress}
                />
                <div className="track-button">
                    <Button
                        buttonText={translate('Track')}
                        variant="tertiary"
                        onClick = {handleTrackingButtonClick}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="tracking-widget" data-testid="tracking-widget">
            <div className="tracking-content">
                {getTrackingIcon()}
                {getTitle()}
                {getTrackingInput()}
            </div>
        </div>
    );
}

export default TrackingNumberWidget;